// src/components/affiliate/CoupangPicks.tsx
import React from 'react';
import { CategoryId } from '../../types';
import { getPicks } from '../../data/coupangPicks';
import { COUPANG_DISCLOSURE } from '../../config/coupang';
import Icon from '../common/Icon';

interface CoupangPicksProps {
    slug: string;
    category: CategoryId;
    title?: string;
}

/**
 * 쿠팡 파트너스 추천 상품 카드.
 *
 * src/data/coupangPicks.ts 에 링크가 없으면 아무것도 렌더링하지 않습니다.
 * 제휴 링크는 검색엔진 지침에 따라 rel="sponsored nofollow" 로 표기하고,
 * 공정위 고지 문구를 링크 바로 옆에 함께 노출합니다.
 */
const CoupangPicks: React.FC<CoupangPicksProps> = ({
    slug,
    category,
    title = '신청과 함께 챙기면 좋은 것',
}) => {
    const picks = getPicks(slug, category);
    if (picks.length === 0) return null;

    return (
        <section className="gh-block gh-cpang">
            <h2 className="gh-block__title">{title}</h2>
            <p className="gh-cpang__notice">
                <Icon name="shield" size={14} strokeWidth={2.2} />
                <span>{COUPANG_DISCLOSURE}</span>
            </p>

            <ul className="gh-cpang__list">
                {picks.map(p => (
                    <li key={p.url} className="gh-cpang__item">
                        <a
                            className="gh-cpang__link"
                            href={p.url}
                            target="_blank"
                            rel="sponsored nofollow noopener noreferrer"
                        >
                            {p.image ? (
                                <img
                                    className="gh-cpang__thumb"
                                    src={p.image}
                                    alt=""
                                    loading="lazy"
                                    width={72}
                                    height={72}
                                />
                            ) : (
                                <span className="gh-cpang__thumb gh-cpang__thumb--empty">
                                    <Icon name="grid" size={22} />
                                </span>
                            )}
                            <span className="gh-cpang__body">
                                <span className="gh-cpang__name">{p.title}</span>
                                {p.note && <span className="gh-cpang__desc">{p.note}</span>}
                                {p.badge && <span className="gh-cpang__badge">{p.badge}</span>}
                            </span>
                            <Icon
                                name="external"
                                size={15}
                                strokeWidth={2.2}
                                className="gh-cpang__arrow"
                            />
                        </a>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default CoupangPicks;
